<template>
    <base-card
        :key="user.id"
        :clickable="true"
        :image="user.main_avatar ? user.main_avatar : user.avatar"
        :cta="{
            text: cta,
            disabled: false
        }"
        :styles="{
            card: {
                position: 'relative',
                maxWidth: maxWidth
            }
        }"
        @cta-clicked="onCardClicked"
        @card-clicked="onCardClicked"
    >
        <template #content-main>
            <div class="venue-info">
                <p class="venue-name">{{ user.venue_name }}</p>
                <p class="venue-location">
                    {{ user.address }}
                </p>
            </div>
            <p class="vibes">{{ findVenueType(user) }}</p>
            <div v-show="user.venue_stats" class="socials">
                <div
                    v-for="social in venueSocials(user.venue_stats)"
                    :key="social.id"
                    class="social"
                >
                    <img :src="social.icon" alt="social-icon" class="social-icon" />
                    <p class="followers">{{ social.followers }}</p>
                </div>
            </div>
        </template>
        <template #footer-text>
            <p v-if="user.capacity" class="footer-text">{{ user.capacity }} guests</p>
        </template>
    </base-card>
</template>
<script>
    import BaseCard from '@/components/ui/cards/BaseCard.vue'
    import useFormattedData from '@/composables/useFormattedData'
    import { venueTypes } from '../../user/venue-types'

    const URLS = {
        redirect: {
            venue: '/venues'
        },
        icons: {
            instagram: '/images/icons/instagram-grey.svg',
            tiktok: '/images/icons/tiktok-grey.svg',
            youtube: '/images/icons/youtube-grey.svg'
        }
    }
    export default {
        name: 'Venue',
        components: {
            BaseCard
        },
        props: {
            user: {
                type: Object,
                required: true
            },
            maxWidth: {
                type: String,
                required: false,
                default: '343px'
            },
            cta: {
                type: String,
                required: false,
                default: 'More Details'
            }
        },
        setup() {
            const { formatBigNumbers } = useFormattedData()
            return {
                formatBigNumbers
            }
        },
        computed: {
            URLS: () => URLS,
            venueSocials: (self) => (socialsInfo) => {
                return !socialsInfo
                    ? null
                    : Object.keys(socialsInfo)
                          .filter(
                              (key) =>
                                  [
                                      // backend data keys
                                      'instagramStat',
                                      'tiktokStat',
                                      'youtubeStat'
                                  ].includes(key) &&
                                  socialsInfo[key] &&
                                  Array.isArray(socialsInfo[key]) &&
                                  socialsInfo[key].length
                          )
                          .reduce(
                              (prev, val, indx) => [
                                  ...prev,
                                  // social object
                                  {
                                      id: indx,
                                      icon: self.URLS.icons[val.replace('Stat', '')],
                                      followers: self.formatBigNumbers(
                                          socialsInfo[val][0].followers
                                      )
                                  }
                              ],
                              []
                          )
            },
            findVenueType: () => (venue) => {
                const result = venueTypes.find((e) => e.val === venue.venue_type)
                return result?.label
            }
        },
        methods: {
            onCardClicked() {
                window.open(`${this.URLS.redirect.venue}/${this.user.slug}`, '_blank')
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../sass/_variables.scss';
    .venue-name {
        color: $white;
        font-variant-numeric: ordinal;
        @include base-font-20;
        font-weight: 600;
        line-height: 24px;
    }
    .venue-location {
        color: $white;
        font-variant-numeric: ordinal;
        @include base-font-12;
    }
    .vibes {
        overflow: hidden;
        color: $darker-grey;
        font-variant-numeric: ordinal;
        text-overflow: ellipsis;
        @include base-font-12;
        font-weight: 400;
    }
    .socials {
        @include flex-row;
        @include flex-justify-start;
        align-items: center;
        width: 100%;
        height: 16px;
        overflow: auto;
        gap: 16px;

        .social {
            @include flex-row;
            @include flex-justify-start;
            align-items: center;
            gap: 4px;

            .social-icon {
                width: 16px;
                height: 16px;
                object-fit: contain;
            }
            .followers {
                color: $darker-grey;
                @include base-font-12;
            }
        }
    }
    .footer-text {
        color: $lighter-grey;
        font-variant-numeric: ordinal;
        @include base-font-16;
        line-height: 24px;
    }
</style>
